export interface CheckoutItbDirectResponse {
  itbId: string;
  paymentRedirectUrl: string;
}
